import { render, staticRenderFns } from "./HotKeywords.vue?vue&type=template&id=ffdb4cf4&scoped=true"
import script from "./HotKeywords.vue?vue&type=script&lang=js"
export * from "./HotKeywords.vue?vue&type=script&lang=js"
import style0 from "./HotKeywords.vue?vue&type=style&index=0&id=ffdb4cf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdb4cf4",
  null
  
)

export default component.exports